import BlueScrollWindowPrompt from "../../common/BlueScrollWindowPrompt";
import ErrorHandler from "../../../services/ErrorHandler/ErrorHandler.js";
import TopDisplayLeft from "./topDisplayLeft/index.js";
import TopDisplayRight from "./topDisplayRight/index.js";
import MiddleDisplay from "./middleDisplay/index.js";
import { useTranslation } from "react-i18next";
import "./displayComponentHomePage.css";

const DisplayComponentHomePage = ({
    showEula,
    showPrivacyPolicy,
    params,
    loginLink,
}) => {
    const { t: tEula } = useTranslation("eula");
    const { t: tPrivacyPolicy } = useTranslation("privacyPolicy");

    const appNotificationDisplays = (
        <>
            {params ? (
                <p className="displayComponentHomePageErrorMessage">
                    {ErrorHandler.displayMessage(params)}
                </p>
            ) : (
                <></>
            )}

            <div className="displayComponentHomePagetermsOfServcieDisplayContainer">
                <BlueScrollWindowPrompt />
            </div>

            <p
                className="displayComponentHomePagetermsOfServcieDisplayText"
                onClick={() => {
                    showEula();
                }}
            >
                {tEula("termsOfServiceTitle")}
            </p>
            <p
                className="displayComponentHomePagePrivacyPolicyDisplayText"
                onClick={() => {
                    showPrivacyPolicy();
                }}
            >
                {tPrivacyPolicy("privacyPolicyTitle")}
            </p>
        </>
    );

    const displayComponent = (
        <div className="homePageWrapper">
            <div className="displayComponentHomePageContainerTop">
                {appNotificationDisplays}
                <TopDisplayLeft loginLink={loginLink} />
                <TopDisplayRight />
            </div>

            <div className="displayComponentHomePageWaveContainer">
                <div className="displayComponentHomePageWaveDisplay"></div>
            </div>

            <MiddleDisplay />
        </div>
    );

    return displayComponent;
};

export default DisplayComponentHomePage;
